import { render } from "./getServer.vue?vue&type=template&id=8ba9dd54&scoped=true"
import script from "./getServer.vue?vue&type=script&lang=js"
export * from "./getServer.vue?vue&type=script&lang=js"

import "./getServer.vue?vue&type=style&index=0&id=8ba9dd54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ba9dd54"]])

export default __exports__